import { Button } from "@heroui/react";
import { type NotFoundRouteProps, useRouter } from "@tanstack/react-router";

import { useLanguage } from "@onesolution/hooks";

export default function NotFoundPage(props: NotFoundRouteProps) {
	const { data } = props;
	const { t } = useLanguage();
	const router = useRouter();

	if (import.meta.env.DEV) console.log(data);

	return (
		<div className="size-full flex flex-col justify-center items-center gap-5">
			<h1>{t("notFoundPage")}</h1>

			<Button
				variant="shadow"
				onPress={() =>
					router.navigate({ to: "/", replace: true, reloadDocument: true })
				}
			>
				{t("basic.goBackHome")}
			</Button>
		</div>
	);
}
